import { FalsoKey, FalsoRandFnOverride } from "src/types/falso.types";

export const falsoOverwrites: Partial<
  Record<FalsoKey, Partial<FalsoRandFnOverride>>
> = {
  randAwsRegion: { displayName: "AWS Region" },
  randAwsRequestId: { displayName: "AWS Request Id" },
  randAwsService: { displayName: "AWS Service" },
  randCreditCardCVV: { displayName: "Credit Card CVV" },
  randGitCommitSha: { displayName: "Git Commit SHA" },
  randHttpMethod: { displayName: "HTTP Method" },
  randIban: { displayName: "IBAN" },
  randImg: { displayName: "Image" },
  randIp: { displayName: "IP Address" },
  randNearbyGPSCoordinate: { displayName: "Nearby GPS Coordinate" },
  randOAuthProvider: { displayName: "OAuth Provider" },
  randSvg: { displayName: "SVG" },
  randUuid: { displayName: "UUID" },
};
